export default {
  namespaced: true,
  hanwha_log: {
    title: "DVR records",
    dvr: "DVR",
    autoDetectDvr: "Auto-detect DVR(s)",
    autoDetectDvrHint: "Automatically use the alarm's unit DVR(s)",
    typeLog: "Log type",
    typeEvent: "Event type",
    dateRange: "Date range",
    dateRangeNone: "None",
    dateRangeLast30: "Last 30 days",
    dateRangeLast60: "Last 60 days",
    dateRangeHint: "Calculated from the moment the alarm view is opened",
  },
};
